//倒入模块

import axios from "axios";
import Qs from "qs";
import router from "../router";
import Vue from "vue";

function getBaseUrl() {
  return Vue.prototype.baseURL;
}
export default function fetch(options) {
  return new Promise((resolve, reject) => {
    //创建一个axios实例
    const instance = axios.create({
      //设置默认根地址
      baseURL: "/api",
      // baseURL: getBaseUrl(),
      timeout: 200000,
      withCredentials: true
      // credentials: 'include'
      // transformRequest: [function (data) {
      //   data = Qs.stringify(data);
      //   return data;
      // }],
    });

    //请求处理
    instance(options)
      .then(({ data: { code, result, data } }) => {
        //请求成功时，
        if (code === 200) {
          resolve({
            code,
            result,
            data
          });
          return false;
        } else if (code === 401) {
          router.replace({
            name: login
          });
        } else if (code === 404) {
          resolve({
            code,
            result,
            data
          });
          return false;
        } else if (code === 201) {
          resolve({
            code,
            result,
            data
          });
          return false;
        } else {
          reject({
            code,
            result,
            data
          });
        }
      })
      .catch(error => {
        //请求失败时，根据业务判断状态
        if (error.response) {
          let resError = error.response;
          let resCode = resError.status;
          let resMsg = error.message;
          // Message.error("操作失败！错误原因" + resMsg);
          reject({
            code: resCode,
            result: resMsg
          });
        }
      });
  });
}



// WEBPACK FOOTER //
// ./src/fetch/index.js